/* ============================================================
   Flèches de carrousel — Stratégie 2
   Ajoute des flèches prev/next aux carrousels horizontaux
   (mobile + carrousels desktop). Les flèches se masquent
   automatiquement aux extrémités et quand rien n'est scrollable.
   Le style (verre liquide / fin liseré) vient de la classe body
   lf-arrows-glass / lf-arrows-liseret (réglage thème).
   ============================================================ */
(function () {
  'use strict';

  /* Le script n'est plus charge par la mise en page mais par chaque
     section qui en a besoin. Deux de ces sections sur une meme page
     sortiraient deux balises, et deux executions poseraient deux jeux
     de fleches. On ne s'installe qu'une fois. */
  if (window.lfCarouselNavCharge) return;
  window.lfCarouselNavCharge = true;

  var SELECTORS = [
    '.lf-fc__grid',
    '.lf-testimonials__track',
    '.lf-testimonials__grid',
    '.lf-blog__grid',
    '.lf-lookbook__grid',
    '.lf-split',
    '.lf-tech-specs__grid',
    '.collage',
    '.collection-list',
    '.lf-ba__grid',
    '.multicolumn-list',
    '.lf-mcol__grid--swipe'
  ];

  var registry = [];

  function makeBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lf-carousel-arrow lf-carousel-arrow--' + dir + ' is-hidden';
    var s = window.lfStrings || {};
    b.setAttribute('aria-label', dir === 'prev' ? (s.previous || 'Previous') : (s.next || 'Next'));
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function setup(track) {
    if (track.dataset.lfNav) return;
    track.dataset.lfNav = '1';

    var parent = track.parentElement;
    if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    var prev = makeBtn('prev');
    var next = makeBtn('next');
    parent.appendChild(prev);
    parent.appendChild(next);

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    function refresh() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      // Flèche gauche masquée quand le carrousel est déjà collé à gauche (ou non scrollable)
      prev.classList.toggle('is-hidden', !scrollable || track.scrollLeft <= 4);
      next.classList.toggle('is-hidden', !scrollable || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
    }
    track.addEventListener('scroll', refresh, { passive: true });
    registry.push(refresh);
    requestAnimationFrame(refresh);
    // Rafraîchissements différés : la largeur peut changer après le chargement des images
    [150, 500, 1000].forEach(function (d) { setTimeout(refresh, d); });
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
  }

  /* Acces clavier aux pistes qui defilent.
     Une piste horizontale sans enfant focalisable est un cul-de-sac au
     clavier : son contenu hors cadre — jusqu'a 2 250 px pour la galerie
     produit — n'est atteignable qu'a la souris. Plutot qu'une liste de
     selecteurs a tenir a jour, on interroge la mise en page. Toutes les
     lectures d'abord, les ecritures ensuite : un seul calcul de mise en
     page au lieu d'un par element. Le debordement depend de la largeur
     d'ecran, donc on repasse apres un redimensionnement. */
  function ouvrirAuClavier() {
    var tous = document.body.getElementsByTagName('*');
    var candidats = [];
    for (var i = 0; i < tous.length; i++) {
      if (tous[i].scrollWidth - tous[i].clientWidth >= 8) candidats.push(tous[i]);
    }
    var mots = window.lfStrings || {};
    candidats.forEach(function (e) {
      if (e.hasAttribute('tabindex')) return;
      var ox = getComputedStyle(e).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') return;
      if (e.querySelector('a[href], button, input, select, textarea, [tabindex]')) return;
      e.setAttribute('tabindex', '0');
      if (!e.hasAttribute('role')) e.setAttribute('role', 'group');
      if (!e.hasAttribute('aria-label')) {
        e.setAttribute('aria-label', mots.scrollable || 'Scrollable content');
      }
    });
  }

  function run() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(setup);
    });
    ouvrirAuClavier();
  }

  function refreshAll() {
    registry.forEach(function (fn) { fn(); });
  }

  function boot() {
    run();
    requestAnimationFrame(refreshAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', function () { setTimeout(function () { run(); refreshAll(); }, 200); }, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();
